import { useSelector } from "react-redux";

export const useIsMultiTenancyEnabledFeatureFlag = () => {
    return useSelector((state: GlobalState) => state.configurationArea.currentSpace.isMultiTenancyEnabled);
};

export default useIsMultiTenancyEnabledFeatureFlag;
